import { restoreStoreContext } from './storeContext';

/**
 * Initialize app before React mounts
 * This ensures critical context (like store headers) is restored
 * BEFORE any components try to make API calls
 */
export const initializeApp = () => {
  console.log('Initializing app...');
  
  // Restore store context from localStorage
  // This sets the x-storeid header for all axios requests
  const restoredStore = restoreStoreContext();
  
  if (restoredStore) {
    console.log('App initialized with store:', restoredStore._id);
  } else {
    console.log('App initialized without store context');
  }
  
  return {
    storeRestored: !!restoredStore,
    store: restoredStore
  };
};

